
const qiniu: any = require("qiniu-js");
let editor: any = null;
import { Request } from "@/api/request";
import { ElMessage } from "element-plus";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {getBranchStoreList, getQiNiuYunToken, getStoreTotalList} from "@/api/http";
import { useRoute, useRouter } from "vue-router";
import E from "wangeditor";
import { storeUser } from "@/store/User";

export default defineComponent({
    name: "vipCardAdd",
    setup() {
        const Router = useRouter();
        const Route = useRoute();
        const setTitle: any = inject("setTitle");
        setTitle(["运营管理", "新增尊享卡"]);
        let user = storeUser.getUser();
        let form: any = ref({
                title: "",
                price: "",
                percentage: "",
                end_time: "",
                backgroundimg: "",
                vice_title: "",
                content: "",
                stock_number:"",
                is_show:0,
                store_ids:"",
            }),
            formRef: any = ref(null),
            userinfo = ref(false),
            form_load = ref(false),
            store_ids = ref([]),
            VipCardId = '',
            imgKey= '';
        const rules: any = ref({
            title: [
                {
                    required: true,
                    message: "请输入尊享卡名称",
                    trigger: "blur",
                },
            ],
            store_ids: [
                {
                    required: true,
                    message: "请选择适用门店",
                    trigger: "blur",
                },
            ],
            stock_number: [
                {
                    required: true,
                    message: "请输入尊享卡库存",
                    trigger: "blur",
                },
            ],
            price: [
                {
                    required: true,
                    message: "请输入价格",
                    trigger: "blur",
                },
            ],
            end_time: [
                {
                    required: true,
                    message: "请输入有效期",
                    trigger: "blur",
                },
                { type: "number", message: "有效期必须为数字值" },
            ],
            backgroundimg: [
                {
                    required: true,
                    validator: (
                        rule: any,
                        value: string,
                        callback: Function
                    ) => {
                        if (form.value.backgroundimg) {
                            callback();
                        } else {
                            callback(new Error("请上传卡片背景图"));
                        }
                    },
                    trigger: "change",
                },
            ],
        });
        // 上传图片功能
        let token = "",
            bucketURL = "",
            uploadImg = (file: any) => {
                return new Promise((resolve: any, rejetc) => {
                    let config = {
                        useCdnDomain: true,
                        // region: qiniu.region.z2,
                    };
                    let putExtra = {
                        fname: "",
                        params: {},
                        mimeType: null,
                    };
                    let observable: any = {};

                    observable = qiniu.upload(
                        file,
                        null,
                        token,
                        putExtra,
                        config
                    );
                    const observer = {
                        next(res: any) {},
                        error(err: any) {},
                        complete(res: any) {
                            resolve(res);
                        },
                    };
                    observable.subscribe(observer);
                });
            },
            beforeAvatarUpload = (file: File) => {
                const isJPG = file.type === "image/jpeg";
                const isPNG = file.type === "image/png";
                if (!isJPG && !isPNG) {
                    ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                }
                return isJPG && isPNG;
            },
            handleChange = (file: any) => {
                uploadImg(file.raw).then((res: any) => {
                    form.value.backgroundimg = bucketURL + res.key;
                    imgKey = res.key
                });
            },
			onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        form.value.content = editor.txt.html();
                        let data = form.value;
                        data.backgroundimg = imgKey;
                        data['store_list'] = form.value.store_ids.toString();
                        form_load.value = true;
                        if (Route.name == "VipCardEdit") {
                            data = {
                                ...data,
                                vip_id:VipCardId
                            }
                            Request.axiosInstance({
                                url: "adminapi/VipCard/edit",
                                data,
                            }).then((res: any) => {
								if((res.status == 202)){
									Router.go(-1);
								}
                            });
                        } else{
                            Request.axiosInstance({
                                url: "adminapi/VipCard/create",
                                data,
                            }).then((res: any) => {
								if((res.status == 202)){
									Router.go(-1);
								}
                            });
                        }
                            
                    }
                });
            };

        onMounted(() => {
            let complete = false;
            if (Route.name == "VipCardEdit") {
                Request.axiosInstance({
                    url: "adminapi/VipCard/info",
                    data: {
                        vip_id: Route.query.id,
                    },
                }).then((res: any) => {
                    complete = true;
                    if (res.status == 200) {
                        let data = res.content.list;
                        data.type = `${data.type}`;
						let imageKey = data.backgroundimg.key;
                        data.backgroundimg = data.backgroundimg.url;
    
                        let need_arr = [];
                        if (data.public_store){
                            for (const arrElement of data.public_store.split(',')) {
                                need_arr.push(Number(arrElement));
                            }
                        }
                        form.value = {
                            title: data.title,
                            price: data.price,
                            percentage: data.percentage,
                            end_time: data.end_time,
                            backgroundimg: data.backgroundimg,
                            vice_title:data.vice_title,
                            content:data.content,
                            stock_number:data.stock_number,
                            is_show:data.is_show,
                            store_ids:need_arr
                        };
                        // Object.keys(form.value).forEach((key) => {
                        //     form.value[key] = data[key];
                        // });
                        imgKey = imageKey
						console.log(imgKey)
                        VipCardId = data.id
                    }
                });
            }
            getQiNiuYunToken().then((res: any) => {
                token = res.content.token;
                bucketURL = res.content.domain;
            });
            let info;
            let user_info = localStorage.getItem('user_info');
            if (user_info) {
                info = JSON.parse(user_info);
                if (info.store_id==0){
                    userinfo.value = true;
                }
            }
            if (info.store_id==0){
                getStoreTotalList({}).then((res:any)=>{
                    store_ids.value = res?.content?.list;
                });
            }else {
                getBranchStoreList({}).then((res:any)=>{
                    store_ids.value = res.content.list;
                });
            }
            editor = new E("#editor");
            editor.config.menus = [
                "head",
                "bold",
                "fontSize",
                "fontName",
                "italic",
                "underline",
                "strikeThrough",
                "indent",
                "lineHeight",
                "foreColor",
                "backColor",
                "link",
                "list",
                "quote",
                "image",
                "video",
                "table",
                "splitLine",
                "undo",
            ];
            editor.config.customUploadImg = function (
                resultFiles: any,
                insertImgFn: any
            ) {
                // resultFiles 是 input 中选中的文件列表
                // insertImgFn 是获取图片 url 后，插入到编辑器的方法
                console.log(resultFiles);
                // 上传图片，返回结果，将图片插入到编辑器中
                if (resultFiles.length > 1) {
                    ElMessage.error("只可选择一张!");
                    return;
                }

                for (var i = 0; i < resultFiles.length; i++) {
                    if (
                        !(
                            resultFiles[i].type != "image/jpeg" ||
                            resultFiles[i].type != "image/png"
                        )
                    ) {
                        ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                        return;
                    }

                    //uploadImg(resultFiles[i].)
                }

                uploadImg(resultFiles[0]).then((res: any) => {
                    let url = bucketURL + res.key;
                    insertImgFn(url);
                });
            };
            editor.create();
            let setEditorText = () => {
                setTimeout(() => {
                    if (complete) {
                        editor.txt.append(form.value.content);
                    } else {
                        setEditorText();
                    }
                }, 100);
            };
            if (Route.name == "VipCardEdit") {
                setEditorText();
            }
        });

        return {
            user,
            form,
            formRef,
            rules,
            beforeAvatarUpload,
            handleChange,
            editor,
            onSubmit,
            form_load,
            userinfo,
            store_ids
        };
    },
});
